<template>
  <b-modal
    id="modal-instruments"
    :title="editModel.id ? $t('reference.edit_ins') : $t('reference.add_ins')"
    cancel-variant="outline-secondary"
    :ok-title="editModel.id ? $t('edit') : $t('save')"
    :ok-variant="editModel.id ? 'warning' : 'success'"
    :cancel-title="$t('cancel')"
    centered
    no-close-on-backdrop
    @show="onShow"
    @ok="onSubmitModel"
  >
    <b-form>
      <validation-observer ref="modelValidations">
        <b-tabs content-class="pt-1" fill>
          <b-tab active :title="$t('reference.name') + ' uz'">
            <b-form-group :label="$t('reference.name')" for="titleUz">
              <validation-provider
                #default="{ errors }"
                :name="$t('namee') + ' uz'"
                rules="required"
              >
                <b-form-input id="titleUz" v-model="categoryy.title.uz" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-tab>

          <b-tab :title="$t('reference.name') + ' ru'">
            <b-form-group :label="$t('reference.name')" for="titleRu">
              <validation-provider
                #default="{ errors }"
                :name="$t('namee') + ' ru'"
                rules="required"
              >
                <b-form-input id="titleRu" v-model="categoryy.title.ru" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-tab>
        </b-tabs>
      </validation-observer>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BModal,
  VBModal,
  BForm,
  BFormInput,
  BFormGroup,
  BTabs,
  BTab,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { mapActions } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  components: {
    BModal,
    BForm,
    BFormInput,
    BFormGroup,
    BTabs,
    BTab,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  props: {
    editModel: {
      type: Object,
      default: () => ({}),
      required: false,
    },
  },
  data() {
    return {



      // ===============  PRIMARY_DATA_SECTION START ===============
      categoryy: {
        title: {
          uz: "",
          ru: "",
        },
        category: null,
      },
      // ===============  PRIMARY_DATA_SECTION END ===============



    };
  },

  methods: {
    ...mapActions("instruments", [
      "CREATE_INSTRUMENTS_MODEL",
      "FETCH_INSTRUMENTS_MODEL",
      "UPDATE_INSTRUMENTS_MODEL",
    ]),





    // ===============  ON_SHOW_SECTION START ===============
    onShow() {
      this.categoryy = {
        title: {
          uz: "",
          ru: "",
        },
        category: this.$route.params.category_id,
      };
      if (!this.editModel || !this.editModel.title) {
        return;
      }
      const { title, category, title_full } = this.editModel;

      this.categoryy = {
        title: {
          uz: title_full.uz,
          ru: title_full.ru,
        },
        category,
      };
    },
    // ===============  ON_SHOW_SECTION END ===============








    // ===============  ON_SUBMIT_SECTION START ===============
    async onSubmitModel(bvModalEvt) {
      bvModalEvt.preventDefault();

      await this.$refs.modelValidations.validate().then( async (success) => {
        if (!success) {
          this.$_errToast({message: this.$t('all_fields_are_required')});
          return;
        }

        try {
          if (this.editModel.id) {
            await this.UPDATE_INSTRUMENTS_MODEL({
              id: this.editModel.id,
              data: {
                category: this.categoryy.category.id,
                title: this.categoryy.title
              },
            });
          } else {
            await this.CREATE_INSTRUMENTS_MODEL(this.categoryy);
          }

          await this.$parent.refresh1();
          await this.$bvModal.hide("modal-instruments");

          this.categoryy = {
            title: {
              uz: "",
              ru: "",
            },
          };

          this.$_okToast();
        } catch (err) {
          this.$_errToast(err);
        }
      });
    },
    // ===============  ON_SUBMIT_SECTION END ===============
  },
};
</script>

<style scoped>
</style>
